(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;
        vm.errorPPolicy = null;
        vm.errorPSync = null;
        vm.errorToken = null;
        vm.accounts = null;
        vm.showPassword=[false,false];
        vm.toggleShowPassword=toggleShowPassword;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
        	vm.doNotMatch = null;
            vm.error = null;
            vm.errorPPolicy = null;
            vm.errorPSync = null;
            vm.errorToken = null;
            vm.success = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
            	vm.accounts = null;
            	vm.sending = true;
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function (response) {
                	vm.sending = false;
                    vm.success = 'OK';
                    if (response && response.data) {
                		vm.accounts = response.data.split('<br />');
                	}
                }).catch(function (response) {
                	vm.sending = false;
                	if(response.data === 'IncorrectResetToken')
                		vm.errorToken = true;
                	else if(response.data === 'InvalidPassword')
                		vm.errorPPolicy = 'InvalidPassword';
                	else if(response.data === 'SyncPasswordError')
                		vm.errorPSync = true;
                	else
                		vm.error = 'ERROR';
                });
            }
        }
        
        function toggleShowPassword(index){
        	vm.showPassword[index]=!vm.showPassword[index];
        }
    }
})();
